import TimezoneBtnLayer from './TimezoneBtnLayer';
import TimezoneLayerOnly from './TimezoneLayerOnly';
import TimezoneContentOnly from './TimezoneContentOnly';
import { UI_TYPE, defaultConfig } from './common/const';
import { getParent } from './common/dom';

let instanceMap: Map<HTMLElement, TimezoneContentOnly | TimezoneLayerOnly | TimezoneBtnLayer> = new Map();

const getInstance = () => {
  const config = {...defaultConfig, ...window?.timezoneConfig};
  const $parent = getParent(config) as HTMLElement;
  const usePreventDuplicate = config?.usePreventDuplicate;

  if(usePreventDuplicate) {
    if(instanceMap.get($parent)) {
      return instanceMap.get($parent);
    }
  }

  const instance = setInstance(config?.uiType);
  instanceMap.set($parent, instance);
  return instance;
};

const setInstance = (uiType: typeof UI_TYPE[keyof typeof UI_TYPE] = UI_TYPE.BTN_LAYER) => {
  switch(uiType) {
    case UI_TYPE.CONTENT_ONLY:
      return new TimezoneContentOnly();
    case UI_TYPE.LAYER_ONLY:
      return new TimezoneLayerOnly();
    default:
      return new TimezoneBtnLayer();
  }
}

export default getInstance;
export type { TimezoneBtnLayer, TimezoneLayerOnly, TimezoneContentOnly };